/*jshint esversion:6*/
import React, { Component } from 'react';

export default class Credits extends Component {
    /*jshint ignore:start*/
    render() {
        return (
            <div>
                <section id="aboutMe">
                    <span style={{flexDirection:"column"}}>
                    <p>
                        Special thanks for the images to @unsplash.com:
                            <ul>
                                <li><a href="https://unsplash.com/photos/UK29635SS6E?utm_source=unsplash&utm_medium=referral&utm_content=creditShareLink">Charles Deluvio</a></li>
                                <li><a href="https://unsplash.com/photos/PJzc7LOt2Ig?utm_source=unsplash&utm_medium=referral&utm_content=creditShareLink">Hope House Press - Leather Diary Studio</a></li>
                                <li><a href="https://unsplash.com/photos/gkQEXwcFRV0?utm_source=unsplash&utm_medium=referral&utm_content=creditShareLink">Francesco De Tommaso </a></li>
                            </ul>
                    </p>
                    </span>
                </section>  
            </div>
        )
    }
    /*jshint ignore:end*/
}
